require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-much-do-e-commerce-websites-cost.json") })
        }
      }, "path---blog-how-much-do-e-commerce-websites-cost");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-much-do-e-commerce-websites-cost!./.cache/json/blog-how-much-do-e-commerce-websites-cost.json
// module id = 453
// module chunks = 231608221292675